import React, { useState } from "react";
import { alpha, styled } from '@mui/material/styles';
import { addChildToLucket, getSpreadsheetData, handleLucketDelete, showCurrentTimes, updateBucket, updateValues } from "../slice/functions";
import { useDispatch, useSelector } from "react-redux";
import { selectBuckets, selectSpreadsheetID, selectTimeFrame, setBucketList } from "../slice/buckets";
import LucketStatusIcon from "./lucketStatusIcon/LucketStatusIcon.cmp";
import LucketActionStatusIcon from "./lucketActionStatusIcon/LucketActionStatusIcon.cmp";
import LucketTime from "./LucketTime";
import LucketCategory from "./lucketCategory/lucketCategory.cmp";
import Draggable from "react-draggable";
//import { createTodoThunk, updateTodo } from "../../todo/slice/functions";
import LucketIcons from "./LucketIcons";
import LucketIcon from "./LucketIcon";
//import { selectTodos } from "../../todo/slice/todo";
import { LucketEditText } from "./LucketEditText/LucketEditText.cmp";
import { AddBucket } from "../AddBucket.cmp";
import "./index.css"
import LucketWeekActionStatusIcon from "./lucketWeekActionStatusIcon/LucketWeekActionStatusIcon.cmp";
import { CATEGORIES, STATUS_OPTION, TIMEFRAME, TimeOptions, TimeOptionsLabel } from "../constants";
import { Paper, TextField, Tooltip } from "@mui/material";
import ConfirmationModal from "./deleteLucketModal";
import IconClose from "./IconClose";
import IconToggle from "./IconToggle";

const NameExpandedTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#A0AAB4',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#B2BAC2',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E0E3E7',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6F7E8C',
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '3em',
    padding: '10px 0', // Adjust padding to ensure text is not cut off
    lineHeight: '1.2', // Adjust line-height to ensure text is properly centered
    textAlign: 'center',
    fontWeight: 'bold',
  },
});

const colorFloatClass = (color) => "LucketCategoryIcon statusfloat-" + color;

export function LucketItemExpanded({ lucket, childLuckets, planView, childLucket, countWeekDonePoints, isExpanded, showDescription }) {
  const dispatch = useDispatch()
  const spreadsheetId = useSelector(selectSpreadsheetID);
  const timeFrame = useSelector(selectTimeFrame);
  //const todos = useSelector(selectTodos);
  const buckets = useSelector(selectBuckets)
  const [editDescription, setEditDescription] = useState(false)
  const [editTitle, setEditTitle] = useState(false)
  const [editingIcon, setEditIcon] = useState(false)
  const [categoryOrderEdit, setCategoryOrderEdit] = useState(false)
  const [scheduleEdit, setScheduleEdit] = useState(false)
  const [addingChild, setAddingChild] = useState(false)

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleConfirmDelete = async () => {
    let result = await handleLucketDelete(lucket)
    console.log(result, "result123")
    dispatch(setBucketList(result.data));
    setOpenModal(false); // Close the modal
  };

  function updateLucket(v, name) {
    let newBucket = updateValues(lucket, name, v);
    updateBucket(newBucket, dispatch, buckets)
  }

  async function addChildLucket() {
    let result = await addChildToLucket(lucket, childLuckets, buckets)
    dispatch(setBucketList(result.data));
  }

  function handleEditDescription() {
    setEditDescription(!editDescription)
  }

  function cutDescription() {
    let newLength = 40
    let addition = ""
    if (lucket.description.split('\n')[0].substring(0, newLength) !== lucket.description.split('\n')[0]) {
      addition = "..."
    }
    return lucket.description.split('\n')[0].substring(0, newLength) + addition
  }

  function calculateBorderColor() {
    let calculatedBorderColor = lucket.status
    return calculatedBorderColor
  }

  function calculateTextColor(backgroundColor) {
    const color = backgroundColor.toLowerCase();
    if (color === STATUS_OPTION.Black || color === STATUS_OPTION.Blue || color === STATUS_OPTION.Green || color === STATUS_OPTION.Purple || color === STATUS_OPTION.Red) {
      return "white";
    }
    return "black";
  }

  function setCategory(event, v) {
    event.stopPropagation();
    setCategoryOrderEdit(false);
    updateLucket(v, "category");
  }

  function setPoints(event, v) {
    event.stopPropagation();
    if (v === "plus") {
      let order = Number(lucket.order)
      if (order && lucket.order < 25) order += 1;
      if (!order) order = 1
      updateLucket(order, "order");
    }
    if (v === "minus") {
      let order = Number(lucket.order)
      if (order && order > 1) order -= 1;
      if (!order) order = 1
      updateLucket(order, "order");
    }
  }

  const classForOption = (option, lucket) => {
    if (typeof lucket.time === "object" && lucket.time[option]) {
      return 'LucketTimeIconShort HighligtedTimeIcon';
    } else {
      return 'LucketTimeIconShort';
    }
  }

  const setTime = (event, v) => {
    event.stopPropagation();
    let currentTime = lucket.time ? { ...lucket.time } : {}
    currentTime[v] = lucket.time && (lucket.time[v]) ? false : true
    updateLucket(JSON.stringify(currentTime), "time");
  }

  const toggleTime = () => {
    let newTimeValue = JSON.stringify({});
    updateLucket(newTimeValue, "time");
  }

  return <div className="lucketItemExpandedParent">
    <div className="lucketNameExpanded">
      <h1 onClick={handleEditDescription} >{lucket.name}</h1>

      {showDescription && <p className="expandedDescriptionLucket" onClick={handleEditDescription}>{lucket.description}</p>}
    </div>
    {editDescription && <LucketEditText luckets={buckets} isExpanded={isExpanded} editDescription={editDescription} editTitle={editDescription} lucket={lucket} updateLucket={updateLucket} addingChild={addingChild} />}

    <div className="expandedAllDetailsContainer">
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <LucketIcon
          icon={lucket.icon}
          lucket={lucket}
          editingIcon={editingIcon}
          setEditing={setEditIcon}
        />
        <div style={{ margin: "auto" }} onClick={() => { setCategoryOrderEdit(!categoryOrderEdit) }}>
          <span className="expandedDetails" >{lucket.category}</span>
          <span className="expandedDetails" >{lucket.order}</span>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div style={{ margin: "auto 15px" }}>
          <LucketActionStatusIcon timeFrame={timeFrame} status="green" lucket={lucket} updateLucket={updateLucket} />
        </div>}
        {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Week) && <div>
          <LucketWeekActionStatusIcon timeFrame={timeFrame} countWeekDonePoints={countWeekDonePoints} status="green" lucket={lucket} updateLucket={updateLucket} />
        </div>}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div onClick={() => setScheduleEdit(!scheduleEdit)} style={{
          margin: "auto 15px", width: "120px",
          textAlign: "left"
        }}>
          {showCurrentTimes(lucket.time)}
        </div>}
      </div>
    </div>
    <LucketStatusIcon status="green" lucket={lucket} updateLucket={updateLucket} isExpanded />

    {scheduleEdit && <div >
      <h3 style={{ textAlign: "left" }}>Edit Schedule</h3>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        {TimeOptions.map((o, i) => <div title={TimeOptionsLabel[i]} key={o} className={classForOption(o, lucket)} onClick={(e) => setTime(e, o)} > {o} </div>)}
        <IconToggle edit={toggleTime} key={"toggle"} />
        <IconClose edit={() => setScheduleEdit(!scheduleEdit)} key={"close"} />
      </div>
    </div>
    }

    {categoryOrderEdit && <div>
      <h3 style={{ textAlign: "left" }}>Edit Category & Order</h3>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        {CATEGORIES.filter(
          o => o !== lucket.status
        ).map(o =>
          <div key={o} className={'LucketCategoryIconShort'}

            onClick={(e) => setCategory(e, o)} >
            {o}
          </div>
        )}
        <div key={"minus"} style={{ marginRight: "15px" }} className={'LucketCategoryIcon ' + colorFloatClass("minus")}
          onClick={(e) => setPoints(e, "minus")} >
          <img src={'/images/minus.svg'} className="CategoryImage" alt="minus.svg" />
        </div>

        <div key={"plus"} className={'LucketCategoryIcon ' + colorFloatClass("plus")}
          onClick={(e) => setPoints(e, "plus")} >
          <img src={'/images/add.svg'} className="CategoryImage" alt="add.svg" />
        </div>
        <IconClose edit={() => { setCategoryOrderEdit(false) }} key={"close"} />
      </div>
    </div>}
    {editingIcon && <div>
      <h3 style={{ textAlign: "left" }}>Edit Icon</h3>
      <LucketIcons updateLucket={updateLucket} lucket={lucket} setEditing={setEditIcon} />
    </div>}
  </div>

  return <div className="lucketItemParent">
    <Paper className="lucketItem" style={{ marginRight: !childLuckets || childLuckets.length === 0 ? "30px" : "0" }}>
      <div className="lucketItemDetails" style={{ display: 'flex', flexDirection: 'row', marginBottom: !(editDescription || editTitle) && !isExpanded && "50px" }}>


        <LucketStatusIcon status="green" lucket={lucket} updateLucket={updateLucket} />
        <div style={{ display: 'flex', flex: 2, flexDirection: 'row', backgroundColor: "#F6F6F6", width: "100%" }}>

          <LucketCategory lucket={lucket} planView={planView} updateLucket={updateLucket} />

          <LucketIcon
            icon={lucket.icon}
            lucket={lucket}
            editingIcon={editingIcon}
            setEditing={setEditIcon}
          />

          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div style={{ display: 'flex', flexDirection: 'column', margin: "auto 15px" }}>
            <LucketActionStatusIcon timeFrame={timeFrame} status="green" lucket={lucket} updateLucket={updateLucket} />
          </div>}

          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Week) && <div style={{ display: 'flex', flexDirection: 'column', margin: "auto 15px" }}>
            <LucketWeekActionStatusIcon timeFrame={timeFrame} countWeekDonePoints={countWeekDonePoints} status="green" lucket={lucket} updateLucket={updateLucket} />
          </div>}

          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div>
            <LucketTime status={lucket.actionStatus}
              lucket={lucket} updateLucket={updateLucket} />
          </div>}

          <div className="lucketName" onClick={() => setEditTitle(!editTitle)} title={lucket.name} style={{
            margin: 'auto 15px auto 50px', flex: isExpanded ? 10 : 5, fontSize: "2.15em", fontWeight: "bold", whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}>
            {lucket.name}
          </div>

          {/* <div style={{ display: 'flex', flexDirection: 'column', margin: 15 }}>
        <input type='number' defaultValue={lucket[1]} onChange={async (e) => {
          updateLucket(e.target.value, "order")
        }} />
        <h1>{lucket.order}</h1>
      </div> */}

          {!isExpanded && (childLuckets && childLuckets.length > 0) ? (
            <div style={{ marginLeft: "30px", display: 'flex', flexWrap: 'wrap', flex: 5 }}>
              {childLuckets.map((child, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', marginRight: '10px' }}>
                  <span>{child.name}</span>
                  <div style={{ width: '20px', height: '20px', backgroundColor: timeFrame === TIMEFRAME.Week ? child.weekActionStatus : child.actionStatus, marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: calculateTextColor(timeFrame === TIMEFRAME.Week ? child.weekActionStatus : child.actionStatus), fontSize: '0.8em' }}>
                    {timeFrame === TIMEFRAME.Week ? child.weekPoints : child.points}
                  </div>
                </div>
              ))}
            </div>
          ) : !isExpanded && (
            <div onClick={() => {
              handleEditDescription()
            }} style={{ display: 'flex', flexDirection: 'column', margin: 15, flex: 5 }}>
              <TextField variant="standard" value={cutDescription()} />
            </div>
          )}


          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {!childLucket && <div className="addChild hoverable" >
              <img src={"/images/add.svg"} style={{ width: '20px', height: '20px', margin: 'auto' }} onClick={() => addChildLucket()} />
            </div>}
            <div className="hoverable" style={{ padding: "5px" }}>
              <img src={"/images/delete.svg"} onClick={handleOpenModal} style={{ width: '20px', height: '20px', margin: 'auto' }} />
            </div>
          </div>

        </div>
      </div>
      <ConfirmationModal
        open={openModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
      />
      <LucketEditText luckets={buckets} isExpanded={isExpanded} editDescription={editDescription} editTitle={editTitle} lucket={lucket} updateLucket={updateLucket} addingChild={addingChild} />

      {editingIcon && <LucketIcons updateLucket={updateLucket}
        lucket={lucket}
        setEditing={setEditIcon}
      />}

    </Paper>
  </div>
}